













import Vue from 'vue'

export default Vue.extend({
  name: 'BoxContainer',
  props: {
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    classes() {
      return {

      }
    }
  }
})
